import { ButtonGroup, Flex, Link } from "@wayflyer/flyui";
import { useFeatureFlagEnabled } from "posthog-js/react";
import { useIntl } from "react-intl";
import { useCustomerAppConfig } from "undercarriage";
import { useSpaNavigate } from "shared-ui";

import { useFundingApplication } from "../../queries/funding-application/queries";
import { COMMON_MESSAGES } from "../common-messages";
import { CONNECT_APP_ROUTE_PATHS } from "../constants";

import { MESSAGES } from "./message-definitions";
import { BusinessModelGeoLetDown, GeographyLetDown, RevenueLetDown } from "./reasons";

export const EligibilityLetDown = () => {
  const intl = useIntl();
  const {
    data: { customerDomain },
  } = useCustomerAppConfig();
  const isNewOnboardingSetupFlowEnabled = useFeatureFlagEnabled("enable_new_onboarding_setup_flow");
  const { navigate } = useSpaNavigate("FundingApp");
  const { data, isFetchedAfterMount } = useFundingApplication(customerDomain);

  const linkText = intl.formatMessage(MESSAGES.letDownLinkToEligibilityCriteriaAnchor);
  const eligbilityCriteriaMessage = intl.formatMessage(MESSAGES.letDownLinkToEligibilityCriteriaMsg, {
    link: <Link url="https://help-center.wayflyer.com/en/collections/151332-applying-for-funding">{linkText}</Link>,
  });
  const isNewOnboardingSetupFlow = Boolean(
    isNewOnboardingSetupFlowEnabled &&
      data.reportedCustomerSegment &&
      data.reportedProductOffering &&
      data.reportedSalesChannel
  );

  const getBackPath = () => {
    if (!data.ineligibleReason) {
      return undefined;
    }
    return {
      revenue: CONNECT_APP_ROUTE_PATHS.REVENUE_ENTRY,
      geography: undefined,
      business_model_geo: isNewOnboardingSetupFlow
        ? CONNECT_APP_ROUTE_PATHS.BUSINESS_MODEL
        : CONNECT_APP_ROUTE_PATHS.REVENUE_ENTRY,
    }[data.ineligibleReason];
  };

  const backPath = getBackPath();

  return isFetchedAfterMount && data ? (
    <Flex direction="column" gap="4" data-testid="ineligible-screen">
      {data.ineligibleReason
        ? {
            revenue: <RevenueLetDown eligibilityLink={eligbilityCriteriaMessage} fundingApplication={data} />,
            geography: <GeographyLetDown eligibilityLink={eligbilityCriteriaMessage} />,
            business_model_geo: (
              <BusinessModelGeoLetDown
                isNewSetupFlow={isNewOnboardingSetupFlow}
                eligibilityLink={eligbilityCriteriaMessage}
              />
            ),
          }[data.ineligibleReason]
        : null}
      {backPath ? (
        <ButtonGroup
          secondaryAction={{
            onAction: () => navigate(backPath),
            content: intl.formatMessage(COMMON_MESSAGES.backLabel),
          }}
        />
      ) : null}
    </Flex>
  ) : null;
};
